import { Extension } from 'fhir/r4';

export const regexExtensionHandler = (extension: Extension) => ({
  ...extension,
  type: 'regex',
});
